

import { put, call } from "redux-saga/effects";
import { performGetRequest, performPostRequest } from "../../services/apiServices/AxiosUtils";
import { URLS } from "../../services/apiServices/service";



//-----------------------------------------------------------------------------------
export const healthCheckApi = function* healthcheck(action) {
  yield put({type : "SHOW_LOADER"})
  
   try {
     
    // const path = "/health_check";
    const res = yield call(performGetRequest, URLS.HEALTH_CHECK);
    if (res !== undefined && res.data.status === "success") {
      yield action.successCallBack(res)
      yield put({type : "HIDE_LOADER"})
    } else if(res.data.status === "error"){
      yield put({type : "HIDE_LOADER"})
      }
  } catch (error) {
    yield put({type : "HIDE_LOADER"})
    }
};

//-----------------------------------------------------------------------------------
export const getLatestWorkApi = function* getLatestApi(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------
export const getGlobalSearchApi = function* getGlobalSearch(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  try {
    const res = yield call(performGetRequest, path);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

//-----------------------------------------------------------------------------------


export const createSubsribeUser = function* createSubscribe(action) {
  yield put({ type: "SHOW_LOADER" });
  let path = action.path;
  let body = {
    data : {
      first_name : "",
      last_name : "",
      designation : "",
      organisation : "",
      email : "",
      phone : "",

    }
  }
  console.log("action",action.payload)
  return;
  try {
    const res = yield call(performPostRequest, path, body);
    if (res !== undefined && res.status === 200) {
      yield action.successCallBack(res);
      yield put({ type: "HIDE_LOADER" });
    } else if (res.data.status === "error") {
      yield put({ type: "HIDE_LOADER" });
    }
  } catch (error) {
    yield put({ type: "HIDE_LOADER" });
  }
};

